import React, { useMemo, useState } from 'react';
import { CartProvider } from './context/CartContext';
import { Header } from './components/Header';
import { CategoryNav } from './components/CategoryNav';
import { MenuSection } from './components/MenuSection';
import { BowlBuilder } from './components/BowlBuilder';
import { ProductCustomizer } from './components/ProductCustomizer';
import { Cart } from './components/Cart';
import { Checkout } from './components/Checkout';
import { CartBadge } from './components/CartBadge';
import { MENU_PRODUCTS, CATEGORIES } from './data/menuData';
import { Product, CartItemType } from './types/types';
import { useCart } from './context/CartContext';
import { AnimatePresence } from 'framer-motion';
type ViewState = 'menu' | 'bowl-builder' | 'product-customizer' | 'checkout';
function AppContent() {
  const [view, setView] = useState<ViewState>('menu');
  const [activeCategory, setActiveCategory] = useState('Todos');
  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);
  const [editingItem, setEditingItem] = useState<CartItemType | null>(null);
  const {
    addItem
  } = useCart();
  const filteredProducts = useMemo(() => {
    if (activeCategory === 'Todos') return MENU_PRODUCTS;
    return MENU_PRODUCTS.filter(p => p.category === activeCategory);
  }, [activeCategory]);
  const groupedProducts = useMemo(() => {
    const groups: Record<string, Product[]> = {};
    filteredProducts.forEach(p => {
      if (!groups[p.category]) groups[p.category] = [];
      groups[p.category].push(p);
    });
    return groups;
  }, [filteredProducts]);
  const handleAddProduct = (product: Product) => {
    if (product.customizable) {
      setSelectedProduct(product);
      setEditingItem(null);
      setView('product-customizer');
    } else {
      addItem({
        id: `${product.id}_${Date.now()}`,
        productId: product.id,
        name: product.name,
        basePrice: product.price,
        quantity: 1,
        selections: {},
        subtotal: product.price,
        type: product.type || 'bebida'
      });
      // Could add a toast here
    }
  };
  const handleEditItem = (item: CartItemType) => {
    setEditingItem(item);
    if (item.type === 'bowl') {
      setView('bowl-builder');
    } else {
      const product = MENU_PRODUCTS.find(p => p.id === item.productId);
      if (product) {
        setSelectedProduct(product);
        setView('product-customizer');
      }
    }
  };
  return <div className="min-h-screen bg-background w-full flex justify-center" data-id="element-0">
      <div className="w-full max-w-md bg-background min-h-screen relative shadow-2xl overflow-x-hidden" data-id="element-1">
        {view === 'menu' && <>
            <Header onStartOrder={() => {
          setEditingItem(null);
          setView('bowl-builder');
        }} data-id="element-2" />

            <div className="px-4 pb-24" data-id="element-3">
              <CategoryNav activeCategory={activeCategory} onSelectCategory={setActiveCategory} data-id="element-4" />

              {Object.entries(groupedProducts).map(([category, products]) => <MenuSection key={category} title={category} products={products} onAddProduct={handleAddProduct} data-id="element-5" />)}
            </div>

            <CartBadge data-id="element-6" />
            <Cart onCheckout={() => setView('checkout')} onEditItem={handleEditItem} data-id="element-7" />
          </>}

        <AnimatePresence data-id="element-8">
          {view === 'bowl-builder' && <BowlBuilder initialItem={editingItem || undefined} onClose={() => setView('menu')} onSave={item => {
          addItem(item);
          setView('menu');
        }} data-id="element-9" />}

          {view === 'product-customizer' && selectedProduct && <ProductCustomizer product={selectedProduct} initialItem={editingItem || undefined} onClose={() => setView('menu')} onSave={item => {
          addItem(item);
          setView('menu');
        }} data-id="element-10" />}

          {view === 'checkout' && <Checkout onBack={() => setView('menu')} data-id="element-11" />}
        </AnimatePresence>
      </div>
    </div>;
}
export function App() {
  return <CartProvider data-id="element-12">
      <AppContent data-id="element-13" />
    </CartProvider>;
}